import { ChatConfig } from '@type/chat';
import { ProviderKey } from '@type/provider';

import { DEFAULT_MODEL_CONFIG } from './ModelConfig';

/**
 * Default provider to use when none is specified
 */
export const DEFAULT_PROVIDER: ProviderKey = 'anthropic';

/**
 * Default system message to use when none is specified
 * This sets the initial context for the AI assistant
 */
export const DEFAULT_SYSTEM_MESSAGE = `Be my helpful and honest advisor.`;

/**
 * Default chat configuration
 * This provides sensible defaults for chat settings
 */
export const DEFAULT_CHAT_CONFIG: ChatConfig = {
  provider: DEFAULT_PROVIDER,
  modelConfig: {
    ...DEFAULT_MODEL_CONFIG,
  },
};

